import { createConsumer } from '@rails/actioncable'

// Prefer same-origin /cable so Devise session cookies are always sent.
// Absolute wss://host/cable from a meta tag can fail on www vs apex mismatches.
const metaUrl = document.head
  .querySelector('meta[name="action-cable-url"]')
  ?.getAttribute('content')

const cableUrl =
  metaUrl && (metaUrl.startsWith('/') || metaUrl.startsWith(window.location.origin))
    ? metaUrl
    : '/cable'

export default createConsumer(cableUrl)
